// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__gHG3I","hidden":"styles_hidden__1q8Mk"};